import { render, staticRenderFns } from "./showVivaStudentDetails.vue?vue&type=template&id=40c69470&scoped=true&"
import script from "./showVivaStudentDetails.vue?vue&type=script&lang=js&"
export * from "./showVivaStudentDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40c69470",
  null
  
)

export default component.exports